import { render, staticRenderFns } from "./ombudsman-monitoring-modal.vue?vue&type=template&id=000b8b22&"
import script from "./ombudsman-monitoring-modal.vue?vue&type=script&lang=js&"
export * from "./ombudsman-monitoring-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports